import type { DatesRange } from "app/components/campaigns/shared/types";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import { getMinGranularityDays } from "./getMinGranularityDays";

/**
 * Checks if the duration is less than the current granularity
 *
 * @param durationObject
 * @param granularity
 */
export const isDurationLessThanGranularity = (
    durationObject: DatesRange | undefined,
    granularity: GranularityNames | undefined,
): boolean => {
    if (!durationObject || !granularity || granularity === GranularityNames.DAILY) {
        return false;
    }
    const durationInDays = durationObject?.to?.diff(durationObject?.from, "day") + 1;
    return durationInDays < getMinGranularityDays(granularity, durationObject);
};
